import { Dispatch, SetStateAction, useState } from "react";
import { Button, Checkbox, Popup } from "semantic-ui-react";

import {
  carrierListColumns,
  CarrierListColumnKey,
  hideableCarrierListColumns,
  allCarrierListColumnKeys,
} from "components/CarrierList/List/carrierListColumns";

import styles from "./CarrierColumnsPicker.module.scss";

export type CarrierColumnsPickerProps = {
  visibleColumns: CarrierListColumnKey[];
  setVisibleColumns: Dispatch<SetStateAction<CarrierListColumnKey[]>>;
};

const CarrierColumnsPicker = (props: CarrierColumnsPickerProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { setVisibleColumns } = props;

  const toggleColumn = (columnKey: CarrierListColumnKey, isShown: boolean) => {
    setVisibleColumns((currentColumns) => {
      const nextColumns = isShown
        ? [...currentColumns, columnKey]
        : currentColumns.filter((key) => key !== columnKey);

      return allCarrierListColumnKeys.filter((key) =>
        nextColumns.includes(key)
      );
    });
  };

  const hiddenCount =
    hideableCarrierListColumns.length -
    hideableCarrierListColumns.filter((column) =>
      props.visibleColumns.includes(column.key)
    ).length;

  return (
    <Popup
      position="bottom right"
      on="click"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      offset={[6, 0]}
      trigger={
        <Button
          type="button"
          size="tiny"
          basic
          icon="columns"
          content={hiddenCount > 0 ? `Columns (${hiddenCount} hidden)` : "Columns"}
          aria-label="Show or hide columns"
          title="Show or hide columns"
          onClick={() => setIsOpen((wasOpen) => !wasOpen)}
        />
      }
    >
      <Popup.Content>
        <div className={styles.columnsPicker}>
          <div className={styles.header}>Columns</div>

          {hideableCarrierListColumns.map((column) => (
            <Checkbox
              key={column.key}
              id={`column-${column.key}`}
              label={column.text}
              checked={props.visibleColumns.includes(column.key)}
              onChange={(_, { checked }) =>
                toggleColumn(column.key, checked ?? false)
              }
            />
          ))}

          <Button
            type="button"
            size="tiny"
            basic
            className={styles.resetButton}
            onClick={() =>
              setVisibleColumns(carrierListColumns.map((column) => column.key))
            }
          >
            Show all
          </Button>
        </div>
      </Popup.Content>
    </Popup>
  );
};

export default CarrierColumnsPicker;
